import React, { useMemo } from 'react'

interface PopupContentProps {
  popupData: any
}

const replaceLinks = (text: string, link = {}) => {
  return Object.entries(link)?.reduce((updatedText, [word, url]) => {
    const regex = new RegExp(`\\b${word}\\b`, 'g') // Match exact word
    return updatedText?.replace(
      regex,
      `<a href="${url}" style="color:#90caf9" target="_blank">${word}</a>`,
    )
  }, text)
}

const List = ({ list, link, ordered = true }: any) => {
  const li = useMemo(
    () =>
      Object.values(list).map((l: any, index) => (
        <li
          key={`${l}-${index}`}
          dangerouslySetInnerHTML={{ __html: replaceLinks(l, link) }}
          style={{ ...style.common }}
        />
      )),
    [list],
  )

  return ordered ? <ol>{li}</ol> : <ul>{li}</ul>
}
const style = {
  common: { letterSpacing: '0.5px', marginBottom: '16px', fontWeight: 400 },
  subtitle: { fontWeight: 600 },
}

const PopupContent: React.FC<PopupContentProps> = ({ popupData }) => {
  return (
    <>
      {popupData?.map((d: any, i: number) => {
        const v = Object.keys(d)
        const contentKey = v?.includes('list')
          ? `list-${JSON.stringify(d?.list)}-${i}`
          : `${v?.[0]}-${d[v?.[0]]}-${i}`

        if (v?.includes('list')) {
          return (
            <List
              key={contentKey}
              list={d?.list}
              link={d?.link}
              ordered={d?.ordered}
            />
          )
        }
        return (
          <div
            key={contentKey}
            style={{
              ...style.common,
              ...(style?.[v?.[0] as keyof typeof style] || {}),
            }}
            dangerouslySetInnerHTML={{
              __html: replaceLinks(d[v?.[0] as keyof typeof d], d?.link || {}),
            }}
          ></div>
        )
      })}
    </>
  )
}

export default PopupContent
